import { Skeleton, Stack } from '@mui/material'
import type { FC } from 'react'

import { unit } from '@hcr/ui'

import { Path } from '../../../models/navigation'
import { DrawerNavigationBack } from '../../common/drawer-navigation-back'
import { Owner } from '../owner'

export const OwnerBenefitDetailsLoading: FC = () => {
  return (
    <>
      <Owner />
      <DrawerNavigationBack
        open={true}
        anchor='bottom'
        paddingBottom={unit(0)}
        paddingTop={unit(5)}
        paddingLeft={unit(0)}
        paddingRight={unit(0)}
        path={Path.Owner}
      >
        <Stack
          gap={unit(0)}
          paddingBottom={unit(10)}
          paddingTop={unit(0)}
          paddingLeft={unit(7.75)}
          paddingRight={unit(12)}
        >
          <Stack direction='column' gap={unit(0.5)} paddingBottom={unit(3)}>
            <Skeleton width='30%' height={unit(6)} />
            <Skeleton width='80%' height={unit(9.5)} />
          </Stack>

          <Skeleton width='80%' height={unit(6)} />
          <Skeleton width='70%' height={unit(6)} />
          <Skeleton width='90%' height={unit(6)} />
          <Skeleton width='80%' height={unit(6)} />
          <Skeleton width='50%' height={unit(6)} />
        </Stack>
      </DrawerNavigationBack>
    </>
  )
}
